import React from 'react';
import { useParams } from 'react-router-dom';
import PatientFormTemplate from '../components/PatientFormTemplate';
import { getInstrumentTitle } from '../functions/InstrumentRegistry';

export default function InstrumentForm() {
  const { formKey } = useParams();
  const title = getInstrumentTitle(formKey);
  return (
    <PatientFormTemplate formTitle={title} formKey={formKey} />
  );
}


